import * as angular from 'angular';
import {IController} from 'angular';
import * as _ from "lodash";
import {$accountsFactory} from "../../$accounts.factory";

export class AccountSelectListCtrl implements IController {

  isDemand: boolean;
  isBusiness?: boolean;
  isExternal?: boolean;
  isSupply: boolean;
  type: any;
  options: any;
  selectedId: any;
  branchIds: any;
  depotIds: any;
  ngPlaceholder: any;
  excludeIds: any;
  onChange: Function;

  public excludedMap: any;
  private accountsRef: any;
  private loadLimit: number;
  private infiniteScroll: any;
  private queryString: any;
  private selectedKeys: any;

  /* @ngInject */
  constructor(private $accounts: $accountsFactory, private $infiniteScroll, private $log) {
  }

  $onInit() {
    if (!this.options) {
      this.accountsRef = this.$accounts();
      this.loadLimit = 20;

      this.accountsRef.$query(this._getQueryPayload());
      this.infiniteScroll = this.$infiniteScroll(this.accountsRef, this.loadLimit, {getFullData: true});
    }
  }

  $onChanges(changes) {
    if (changes.excludeIds) {
      this.excludedMap = {};
      _.forEach(this.excludeIds, (id) => {
        this.excludedMap[id] = true;
      })
    }
  }

  submitQuery(query) {
    this.queryString = query;
    if (!this.options) {
      this._reload();
    }
  }

  private _reload() {
    this.accountsRef.$query(this._getQueryPayload())
      .then(() => {
        this.infiniteScroll.reload();
      })
      .catch((error) => {
        this.$log.error('Fail to $query', error);
      })
  }

  private _getQueryPayload() {
    return {
      limit: this.loadLimit,
      query: this.queryString,
      isDemand: this.isDemand,
      isBusiness: this.isBusiness,
      isExternal: this.isExternal,
      isSupply: this.isSupply,
      branchIds: this.branchIds,
      depotIds: this.depotIds,
      type: this.type,
      sort: 'name,asc'
    };
  }
}

angular
  .module('bringoz.admin.accounts')
  .component('accountSelectList', {
    bindings: {
      isDemand: '<',
      isBusiness: '<?',
      isExternal: '<?',
      isSupply: '<?',
      type: '<?',
      options: '<?',
      selectedId: '<',
      branchIds: '<?',
      depotIds: '<?',
      ngPlaceholder: '@?',
      excludeIds: '<?',
      onChange: '&'
    },
    template: require('./account-select-list.html').default,
    controller: AccountSelectListCtrl
  });
